<mat-card appearance="outlined" class="flat mt-10" style="margin-bottom: 10px">
  <div class="row">
    <div>
      <h3 [id]="identifierService.labelId('addressAndContactInformation', 'addressContact')" class="merlin-header header-space" data-tx-key="label.gb.address_contact">{{ labels['label.gb.address_contact'] }}</h3>
    </div>
    <div class="pl-15">
      <div>
        <p [id]="identifierService.buttonId('addressContactInfo', 'emergencyContact')" class="sectionTitle popupLink" (click)="onEmergencyContact()" data-tx-key="label.gb.emergency_contact">
          {{ labels['label.gb.emergency_contact'] }}
        </p>
      </div>
    </div>
  </div>
  @if (displayEditUI()) {
    <form [formGroup]="addressDetails">
      <div class="row">
        <div class="col-xs-4 col-md-4 col-lg-4">
                <merlin-textbox tabindex="1" maxLength="100" [groupName]="addressDetails" label="{{ labels['label.gb.address1'] }}" placeHolder="{{ labels['label.gb.address1'] }}" [required]="isAddressFieldRequired"
                    controlName="address"
                    [id]="
                        identifierService.dropdownId(
                            'address-contact-information',
                            'address'
                        )
                    " data-tx-key="label.gb.address1"></merlin-textbox>
        </div>
        <div class="col-xs-4 col-md-4 col-lg-4">
                <merlin-textbox tabindex="7" maxLength="30" [groupName]="addressDetails" label="{{ labels['label.gb.city'] }}" placeHolder="{{ labels['label.gb.city'] }}" [required]="isAddressFieldRequired"
                    controlName="city"
                    [id]="
                        identifierService.dropdownId(
                            'address-contact-information',
                            'city'
                        )
                    " data-tx-key="label.gb.city"></merlin-textbox>
        </div>
        <div class="col-xs-4 col-md-4 col-lg-4">
          <mat-form-field tabindex="11" [formGroup]="addressDetails" class="merlin-select mr-20 full-width" appearance="outline">
            <mat-label [id]="identifierService.labelId('addressContact', 'country')" data-tx-key="label.gb.country">{{ labels['label.gb.country'] }}
            </mat-label>
                    <mat-select disableOptionCentering (selectionChange)="onChangeCountry($event.value)" formControlName="countryCd" label="{{ labels['label.gb.country'] }}" [compareWith]="compareCountryCd" [id]="
                            identifierService.dropdownId(
                                'address-contact-information',
                                'countryCd'
                            )
                        ">
              @for (country of countryList; track country) {
                <mat-option [id]="identifierService.listitemId('address-contact-information', 'countryOption_' + country?.codeId)" [value]="country.codeId">{{ formatDDString(country) }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-4 col-md-4 col-lg-4">
                <merlin-textbox tabindex="2" maxLength="100" [groupName]="addressDetails" label="{{ labels['label.gb.address2'] }}" placeHolder="{{ labels['label.gb.address2'] }}" [required]="false" controlName="address2" [id]="
                        identifierService.dropdownId(
                            'address-contact-information',
                            'address2'
                        )
                    " data-tx-key="label.gb.address2"></merlin-textbox>
        </div>
        <div class="col-xs-4 col-md-4 col-lg-4">
          @if (isSelectedUSACountry) {
            <mat-form-field tabindex="8" [formGroup]="addressDetails" class="merlin-select mr-20 full-width" appearance="outline">
              <mat-label [id]="identifierService.labelId('addressContact', 'stateProvince')" data-tx-key="label.gb.state_province">{{ labels['label.gb.state_province'] }}
              </mat-label>
                        <mat-select [required]="isAddressFieldRequired" formControlName="stateCd" disableOptionCentering label="State/Prov" [compareWith]="compareCountryCd" [id]="
                                identifierService.dropdownId(
                                    'address-contact-information',
                                    'stateProv'
                                )
                            ">
                @for (state of dropDownsList.stateCodes; track state) {
                  <mat-option [id]="identifierService.listitemId('address-contact-information', 'stateOption_' + state?.codeId)" value="{{ state.codeId }}">{{ formatDDString(state) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (!isSelectedUSACountry) {
                     <merlin-textbox [groupName]="addressDetails" [required]="isAddressFieldRequired"
                        maxLength="30"
                        controlName="state"
                        label="{{ labels['label.gb.state_province'] }}"
                        [id]="
                            identifierService.dropdownId(
                                'address-contact-information',
                                'stateProv'
                            )
                        " data-tx-key="label.gb.state_province"></merlin-textbox>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-xs-4 col-md-4 col-lg-4">
                <merlin-textbox tabindex="3" maxLength="100" [groupName]="addressDetails" label="{{ labels['label.gb.address3'] }}" placeHolder="{{ labels['label.gb.address3'] }}" [required]="false" controlName="address3" [id]="
                        identifierService.dropdownId(
                            'address-contact-information',
                            'address3'
                        )
                    " data-tx-key="label.gb.address3"></merlin-textbox>
        </div>
        <div class="col-xs-4 col-md-4 col-lg-4">
                <merlin-textbox tabindex="9" maxLength="30" [groupName]="addressDetails" label="{{ labels['label.gb.zip_post_code'] }}" placeHolder="{{ labels['label.gb.zip_post_code'] }}" [required]="isAddressFieldRequired"
                    controlName="zipCode"
                    [id]="
                        identifierService.dropdownId(
                            'address-contact-information',
                            'zipCode'
                        )
                    " data-tx-key="label.gb.zip_post_code"></merlin-textbox>
          <!--  pattern="^[0-9]\d*$"-  pattern="^[0-9-.,()+' ']*$"-->
        </div>
      </div>
      <hr /> <br /> <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-4 col-md-4 col-lg-4 p-0 mb-10">
            @if (phoneValidations || requiredPhoneForDirMethod || defaultDirCallMethod) {
              <span data-tx-key="label.gb.primary_phone" class="requiredFields">*</span>
              } {{ labels['label.gb.primary_phone'] }} :
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-4 col-md-4 col-lg-4 row">
            <div class="col-xs-3 col-md-3 col-lg-3 pr-0" style="flex: auto;">
              <mat-form-field tabindex="4" class="merlin-select full-width" [formGroup]="phoneForm" appearance="outline">
                        <input matInput formControlName="countryCode" maxlength="3" pattern="^[0-9\(\).,+\- ]*" [required]="phoneValidations || directCallPhone" [id]="
                                identifierService.dropdownId(
                                    'address-contact-information',
                                    'countryCode'
                                )
                            " />
                  <mat-hint data-tx-key="label.gb.phone_country_code" class="pt-10">{{ labels['label.gb.phone_country_code'] }}
                  </mat-hint>
                </mat-form-field>
              </div>
              <div class="col-xs-3 col-md-3 col-lg-3 pr-0" style="flex: auto;">
                <mat-form-field tabindex="5" class="merlin-select full-width" [formGroup]="phoneForm" appearance="outline">
                        <input matInput formControlName="areaCode" maxLength="5" pattern="^[0-9\(\).,+\- ]*" [id]="
                                identifierService.dropdownId(
                                    'address-contact-information',
                                    'areaCode'
                                )
                            " />
                    <mat-hint data-tx-key="label.gb.phone_area_code" class="pt-10">{{ labels['label.gb.phone_area_code'] }}
                    </mat-hint>
                  </mat-form-field>
                </div>
                <div class="col-xs-6 col-md-6 col-lg-6" style="flex: auto;">
                  <mat-form-field tabindex="6" class="merlin-select full-width" [formGroup]="phoneForm" appearance="outline">
                        <input matInput formControlName="phoneNum" pattern="^[0-9\(\).,+\- ]*" maxLength="12" [required]="phoneValidations || directCallPhone" [id]="
                                identifierService.dropdownId(
                                    'address-contact-information',
                                    'number'
                                )
                            " />
                      <mat-hint data-tx-key="label.gb.phone_number" class="pt-10">{{ labels['label.gb.phone_number'] }}
                      </mat-hint>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4">
                <merlin-textbox maxLength="100" [groupName]="patientDetails" label="{{ labels['label.gb.email'] }}" placeHolder="{{ labels['label.gb.email'] }}" [required]="emailValidations" controlName="email" [id]="
                        identifierService.dropdownId(
                            'address-contact-information',
                            'email'
                        )
                    "
                    data-tx-key="label.gb.email"></merlin-textbox>
            </div>
        </div>

    </form>
  }
</mat-card>
